import { render, staticRenderFns } from "./Lib.vue?vue&type=template&id=7036610a"
import script from "./Lib.vue?vue&type=script&lang=js"
export * from "./Lib.vue?vue&type=script&lang=js"
import style0 from "./Lib.vue?vue&type=style&index=0&id=7036610a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports